<div class="overview">
  <div class="overview__grid">
    <section class="guild-card">
      <h2 class="section-title">
        {{ 'app.patrol.discord.cockpit.overview.guildTitle' | translate }}
      </h2>
      <dl class="meta-list">
        <div class="meta-list__row">
          <dt>{{ 'app.patrol.discord.cockpit.overview.serverName' | translate }}</dt>
          <dd>{{ guild().displayName }}</dd>
        </div>
        @if (guild().communityId) {
          <div class="meta-list__row">
            <dt>{{ 'app.patrol.discord.cockpit.overview.guildId' | translate }}</dt>
            <dd><code>{{ guild().communityId }}</code></dd>
          </div>
        }
        <div class="meta-list__row">
          <dt>{{ 'app.patrol.discord.cockpit.overview.status' | translate }}</dt>
          <dd>
            <span class="status-pill" [attr.data-status]="guild().status">
              {{
                'app.patrol.discord.cockpit.status.' + guild().status | translate
              }}
            </span>
          </dd>
        </div>
        @if (guild().linkedAt) {
          <div class="meta-list__row">
            <dt>{{ 'app.patrol.discord.cockpit.overview.linkedAt' | translate }}</dt>
            <dd>{{ formatDate(guild().linkedAt) }}</dd>
          </div>
        }
        <div class="meta-list__row">
          <dt>{{ 'app.patrol.discord.cockpit.overview.members' | translate }}</dt>
          <dd>{{ guild().memberCount | number }}</dd>
        </div>
        <div class="meta-list__row">
          <dt>{{ 'app.patrol.discord.cockpit.overview.linkedMembers' | translate }}</dt>
          <dd>{{ guild().linkedMemberCount | number }}</dd>
        </div>
      </dl>
    </section>

    <app-patrol-discord-connect-panel
      [botHealth]="botHealth()"
      [displayName]="guild().displayName"
      [guildConnected]="guild().status === 'active'"
      [compact]="true"
    />
  </div>

  @if (guild().status === 'active') {
    <section class="checklist-card">
      <h2 class="section-title">
        {{ 'app.patrol.discord.cockpit.overview.checklistTitle' | translate }}
      </h2>
      <ul class="checklist">
        @for (item of setupChecklist(); track item.id) {
          <li
            class="checklist__item"
            [class.checklist__item--done]="item.done"
          >
            {{ item.labelKey | translate }}
          </li>
        }
      </ul>
    </section>
  }
</div>
